<template>
  <div class="bg-container">
    <div class="login-container">
      <!-- 标题 -->
      <div class="header">
        <div class="header2">
          <img src="../../assets/image/caspd_logo.png" alt="" class="logo">
        </div>
        <div class="header1">
          中国残疾人体育运动管理中心 · 科研管理平台
        </div>
      </div>
      <div class="main">
        <div class="url-list">
          <div><img class="url-img" src="../../assets/image/课题.png" alt="" @click="toKeti"></div>
          <div><img class="url-img" src="../../assets/image/专委会.png" alt="" @click="toZwh"></div>
          <div><img class="url-img" src="../../assets/image/申报.png" alt="" @click="toPapers"></div>

        </div>
      </div>

      <div class="footer">
        <p>中国残疾人体育运动管理中心</p>
        <p>
          地址：北京市顺义区后沙峪镇天北路321号 &nbsp;&nbsp; 电话:010-80471809
          &nbsp;&nbsp;传真：010-80471809
        </p>
        <p>ICP备案号 : 京ICP备15050850号-1 ©2007-2019 中国残疾人体育运动管理中心版权所有 </p>
        <div style="width:300px;margin:0 auto; ">
          <a target="_blank" href=" " style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
            <img src="../../assets/image/公安.jpg" style="float:left;" />
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">京公网安备
              11011302004271号</p>
          </a>
        </div>
        <p>技术维护: 北京或然科技有限公司 电话: 010-88120103</p>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  components: {
  },

  data() {
    return {

    };
  },
  created() { },
  mounted() { },
  methods: {
    toKeti() {
      window.open('/home', "_blank")
      // window.location.href = "zwh.caspd.org.cn"
    },
    toZwh() {
      window.open('http://zwh.caspd.org.cn', "_blank")
      // window.location.href = "zwh.caspd.org.cn"
    },
    toPapers() {
      window.open('http://lwbgh.caspd.org.cn', "_blank")
      // window.location.href = "lwbgh.caspd.org.cn" 
    },
  }
};

</script>

<style lang="less" scoped >
.bg-container {
  display: flex;
  justify-content: center;


  .login-container {
    width: 1440px;
    height: 100%;

    .header {
      width: 100%;
      height: 120px;
      display: flex;
      justify-content: center;
      align-items: center;

      .header2 {
        height: 28px;
        // width: 30px;
        // background: #fff;

        .logo {
          height: 30px;
          margin-top: 5px;
        }
      }

      .header1 {
        width: 580px;
        height: 28px;
        font-size: 28px;
        font-weight: 500;
        text-align: center;
        color: #333333;
      }
    }

    .main {
      margin: 5px 0;
      width: 100%;
      height: 438px;
      background-image: url("../../assets/image/背景.png");
      display: flex;
      justify-content: center;
      align-items: center;

      .url-list {
        width: 800px;
        height: 200px;
        display: flex;
        justify-content: space-between;

        .url-img {
          width: 150px;
          height: 200px;
          opacity: 0.8;
        }

      }
    }

    .footer {
      margin-top: 185px;
      width: 100%;
      height: 38px;
      font-size: 12px;
      font-weight: 400;
      text-align: center;
      color: #888888;
      line-height: 20px;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/home/HomeList.vue